<div
  class="global-notification-component"
  [ngClass]="{
    'va-global-header-icon-focus': isNotificationDropdown
  }"
>
  <a
    nz-dropdown
    nzTrigger="click"
    nzBackdrop="false"
    [nzDropdownMenu]="downloadMenu"
    [(nzVisible)]="isNotificationDropdown"
    (nzVisibleChange)="isDropdownOpen($event)"
  >
    <span (click)="getNotificationDetails('Excel')">
      <nz-badge [nzDot]="downloadBadgeDot">
        <va-icon
          nz-tooltip
          nzTooltipTitle="Downloads"
          nzTooltipPlacement="bottom"
          size="small"
          name="arrow-to-bottom"
        ></va-icon>
      </nz-badge>
    </span>
  </a>
</div>

<nz-dropdown-menu #downloadMenu="nzDropdownMenu">
  <div class="va-global-header-dd-menu">
    <div class="header-container">
      <span
        class="header"
        *ngIf="tabHeaderText"
        [textContent]="tabHeaderText"
      ></span>
    </div>
    <div
      class="sub-header"
      *ngIf="tabDurationText"
      [textContent]="tabDurationText"
    ></div>
    <nz-list
      [nzDataSource]="notificationList"
      [nzLoading]="loading"
      [nzItemLayout]="'vertical'"
      id="globalHeaderNotification"
    >
      <nz-list-item>
        <div class="list-group" *ngFor="let notification of notificationList">
          <div
            class="list-header"
            [textContent]="notification.subHeadText"
          ></div>
          <div
            class="download-list"
            nzGutter="1"
            nz-row
            *ngFor="let alerts of notification.subvalues"
            (click)="onRowClick($event, alerts)"
          >
            <span
              nz-col
              nzSpan="6"
              class="ticker-name"
              *ngIf="
                getEventName(alerts.event_display_name, alerts.extras) !==
                'Research Export'
              "
            >
              {{ alerts.actor.actor_text }}
            </span>
            <span
              nz-col
              nzSpan="6"
              *ngIf="
                getEventName(alerts.event_display_name, alerts.extras) ===
                'Research Export'
              "
            >
              &nbsp;
            </span>
            <span nz-col nzSpan="15">
              {{ getEventName(alerts.event_display_name, alerts.extras) }}
            </span>
            <span nz-col nzSpan="2" class="download-icon">
              <!-- In progress -->
              <span *ngIf="getExcelStatus(processtag, alerts.extras)">
                <va-icon isFontAwesome="true" [name]="faCircleNotch" spin="true"></va-icon>
              </span>
              <!-- Download -->
              <span
                *ngIf="
                  (getExcelStatus(successtag, alerts.extras) &&
                    checkIfPreAndPost(alerts.extras)) ||
                  (getExcelStatus(successtag, alerts.extras) &&
                    !checkIfPreAndPost(alerts.extras))
                "
              >
                <va-icon size="small" name="arrow-to-bottom"></va-icon>
              </span>
              <!-- retry download-->
              <span
                *ngIf="
                  getExcelStatus(failuretag, alerts.extras) &&
                  getRetryStatus(alerts.extras)
                "
                style="padding-right: 4px;"
                title="Try Again"
              >
                <va-icon name="exclamation-triangle"></va-icon>
              </span>
            </span>
          </div>
        </div>
      </nz-list-item>
    </nz-list>
  </div>
</nz-dropdown-menu>
